<!--
  @Description: 公司-关注
  @Author: wang.y 
  @Date: 2022-02-25 
-->
<template>
  <div>
    <div class="hava-data">
      <div class="left">
        <Spin fix v-if="loading1">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        <div class="content">
          <template v-if="atten_org_list.length">
            <div class="sec-title"><span>关注一览</span></div>
            <entity-temp v-for="item,index in atten_org_list" :key="'gz' + item.id" :item="item" :entitytype="1" :class="{'active': active_uid == item.uid}"></entity-temp>
          </template>
          <div class="sec-title sec-title-2"><span>推荐关注</span></div>
          <entity-temp v-for="item,index in $parent.org_reco_list" :key="'tj' + item.id" :item="item" :entitytype="1" :class="{'active': active_uid == item.uid}"></entity-temp>
        </div>
      </div>
      <div class="right">
        <Spin fix v-if="loading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        <div class="comp-detail">
          <div class="sec-title-r">
            <span>对外投资</span>
            <div class="line"></div>
            <div class="lookmore" @click="$parent.goEntityDetail(1, active_uid)" onclick="_czc.push(['_trackEvent', '我的关注(新)', '关注的机构(对外投资_更多)', '点击量'])">查看更多</div>
          </div>
          <div class="list_div">
            <Table :columns="project_columns" :data="project_list"></Table>
            <div class="page clear" v-if="total > 10">
              <Page :total="total" :current="current_page" :page-size="10" show-total class="page_list" @on-change="handlePage" show-elevator />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-list">
      <div class="sec-title-r">
        <span>机构动态-{{active_item.short_name}}</span>
        <div class="line"></div>
      </div>
      <div class="list-wrap">
        <div class="item-list-wider" v-for="item,index in dynamic_list" :key="index">
          <div class="legend">
            <div class="type">{{ typelist[item.content_type] }}</div>
            <div class="list-title-large" @click="$parent.goToDetail(item)" onclick="_czc.push(['_trackEvent', '我的关注(新)', '关注的机构(机构动态_标题)', '点击量'])">{{ item.title }}</div>
            <div class="time" v-if="item.content_type == 3 && item.sort_time">{{ item.sort_time | time_moment}}更新</div>
            <div class="time" v-else>{{ item.publish_time | time_moment}}</div>
          </div>
          <div class="list-tag">
            <div class="name">相关赛道</div>
            <template v-for="item2,index2 in item.app_tag_arr">
              <div class="tag" :key="index2" @click="$parent.goToTrackDetail(item2)" v-if="index2 < 3">{{item2 | dealName($parent.entity_ntag)}}</div>
            </template>
          </div>
        </div>
        <Spin fix v-if="loading3">
          <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </div>
      <div class="list-page" v-if="!(page == 1 && dynamic_list.length < 5)">
        <span :class="{'dis': page == 1}" @click="handleChangePage('prev')">上一页</span>
        <span :class="{'dis': dynamic_list.length < 5}" @click="handleChangePage('next')">下一页</span>
      </div>
      <div class="list-over" v-if="!loading3 && dynamic_list.length == 0">
        <template v-if="page == 1">暂无机构动态</template>
        <template v-else>已全部加载完</template>
      </div>
    </div>
  </div>
</template>
<script>
import { subscribeOverview, entityDetail, switchFocusCompany } from '@/service'
import EntityTemp from './EntityTemp2'
import filter from 'js/filter'
export default {
  components: {
    EntityTemp,
  },
  created() {
    if (this.atten_org_ids.length) this.handleFindEntity('1', this.atten_org_ids)
  },
  mounted() {},
  data() {
    return {
      atten_org_list: [],
      is_init: true,
      loading1: true,
      loading3: true,
      loading: true,
      active_id: '',
      active_uid: '',
      active_item: {},
      project: [],
      project_list: [],
      total: 0,
      current_page: 1,
      project_columns: [
        {
          title: '项目名',
          width: 120,
          render: (h, params) => {
            return h(
              'div',
              {
                class: { company: true },
              },
              [
                h(
                  'div',
                  {
                    class: { logo_img: true },
                    on: {
                      click: () => {
                        this.$parent.goEntityDetail(params.row.ht_comp_type, params.row.comp_uid)
                      },
                    },
                  },
                  [h('img', { attrs: { src: filter.logo_show(params.row.ht_logo_path) } })]
                ),
                h('div', { class: { company_name: true } }, [
                  h('p', [
                    h(
                      'a',
                      {
                        on: {
                          click: () => {
                            this.$parent.goEntityDetail(
                              params.row.ht_comp_type,
                              params.row.comp_uid
                            )
                          },
                        },
                      },
                      params.row.ht_comp_name
                    ),
                  ]),
                ]),
              ]
            )
          },
        },
        {
          title: '业务概况',
          width: 90,
          render: (h, params) => {
            return h(
              'div',
              { class: { 'dec-clamp': true } },
              filter.empty(params.row.ht_description)
            )
          },
        },
        {
          title: '地区',
          key: 'area',
          width: 100,
          render: (h, params) => {
            return h('span', filter.pc(params.row.ht_province, params.row.ht_city))
          },
        },
        {
          title: '行业',
          key: 'tags',
          render: (h, params) => {
            // return h('span', filter.empty(params.row.comp_nxfly))
            if (params.row.tags != '') {
              return h(
                'div',
                { class: 'over-p2' },
                filter.dealString(params.row.tags, 'dynview_tag')
              )
            } else {
              return h('span', '--')
            }
          },
        },
        {
          title: '当前轮次',
          width: 90,
          key: 'round_id',
          render: (h, params) => {
            return h('span', filter.deal(params.row.ht_round, 'round'))
          },
        },
        {
          title: '最近融资时间',
          width: 110,
          key: 'latest_event_time',
          minWidth: 100,
          render: (h, params) => {
            return h('span', filter.timeTrans(params.row.event_time))
          },
        },
        {
          title: '过往参与轮次',
          width: 120,
          key: 'before_round',
          render: (h, params) => {
            if (params.row.before_round.length != 0) {
              let s = params.row.before_round.join(',')
              return h('span', filter.dealString(s, 'round'))
            } else {
              return h('span', '--')
            }
          },
        },
      ],
      page: 1,
      dynamic_list: [],
      typelist: {
        0: '文章',
        1: '视频',
        2: '报告',
        3: '专题Pro',
        4: '快讯',
      },
    }
  },
  computed: {
    attention() {
      return this.$store.state.attention || {}
    },
    atten_org() {
      let arr = this.attention.subscribe.filter((a) => a.sub_type == '1')
      return arr
    },
    atten_org_ids() {
      let ids = []
      this.atten_org.forEach((a) => {
        ids.push(a.sub_type_id)
      })
      return ids
    },
  },
  watch: {
    atten_org_ids(arr) {
      if (arr.length) {
        this.handleFindEntity('1', arr)
      } else {
        this.atten_org_list = []
      }
    },
  },
  methods: {
    /**
     * 获取实体信息
     * @param
     * stype 实体类型 0公司 1机构 (必传)
     * arr 实体id数组
     * keyword 关键字检索
     */
    async handleFindEntity(stype) {
      let res = await subscribeOverview(
        {
          type: stype
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.code == 0) {
        this.$set(this.$data, 'atten_org_list', res.data.res)
        this.loading1 = false
        if (this.is_init) {
          this.is_init = false
          if (res.data.res.length) {
            this.active_uid = res.data.res[0].uid
            this.active_id = res.data.res[0].id
            this.active_item = res.data.res[0]
          } else {
            this.active_uid = this.$parent.org_reco_list[0].uid
            this.active_id = this.$parent.org_reco_list[0].id
            this.active_item = this.$parent.org_reco_list[0]
          }
          this.getDetail(this.active_uid)
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    async getDetail(uid) {
      this.loading = true
      this.page = 1
      this.switchFocusCompany()
      let res = await entityDetail(
        {
          uid: uid,
          type: 'dwtz',
          entity_type: 1,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      this.loading = false
      if (res.status == 'success') {
        this.$set(this.$data, 'project', res.dwtz)
        this.$set(this.$data, 'project_list', [...res.dwtz].slice(0, 10))
        this.total = res.dwtz.length
        this.current_page = 1
      } else {
        this.$Message.error(res.msg)
      }
    },
    handlePage(page) {
      _czc.push(['_trackEvent', '我的关注(新)', '关注的机构(对外投资_翻页控件)', '点击量'])
      this.current_page = page
      this.$set(this.$data, 'project_list', [...this.project].slice(10 * (page - 1), 10 * page))
    },
    handleChangePage(type) {
      _czc.push(['_trackEvent', '我的关注(新)', '关注的机构(机构动态_翻页控件)', '点击量'])
      if(!this.loading3) {
        if (type == 'next') {
          if (this.dynamic_list.length == 5) {
            this.page++
            this.switchFocusCompany()
          }
        } else {
          if (this.page > 1) {
            this.page--
            this.switchFocusCompany()
          }
        }
      }
    },
    async switchFocusCompany() {
      this.loading3 = true
      let res = await switchFocusCompany(
        {
          page: this.page,
          size: 5,
          id: this.active_id,
          uid: this.active_uid,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      this.loading3 = false
      if (res.code == '0') {
        this.$set(this.$data, 'dynamic_list', res.data)
      } else {
        this.$Message.error(res.msg)
      }
    },
  },
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/common2.0.stylus'
.hava-data
  .right
    position relative
  .left
    position relative
    min-height 400px
    .content
      background #F8F9FA
      padding 16px 20px
      overflow auto
      position absolute
      top 0
      left 0
      right 0
      bottom 0
      &::-webkit-scrollbar-track
        background-color #F8F9FA !important
      &::-webkit-scrollbar
        background-color #F8F9FA !important
      &::-webkit-scrollbar-thumb
        background-color #999 !important
    >>> .entity-temp
      height 60px
      cursor pointer
      &:hover
        border-color #FA5A00
      & + div
        margin-top 16px
  .right
    .comp-detail
      background #f8f9fa
      padding 16px 20px
      min-height 300px
      >>> .over-p2
        ellipsisClamp()
        -webkit-line-clamp 2
.data-list
  background #f8f9fa
  padding 16px 20px
  margin-top 12px
  .list-over
    text-align: center
    color #999
    padding 10px 0
  .list-wrap
    display flex
    flex-direction column
    border-left 2px solid #F3F3F3
    position relative
    .ivu-spin-fix
      left -2px
      background-color #f8f9fa
    
    .item-list
      position relative
      left -2px
      // height fit-content
    .item-list-wider
      margin-bottom 10px
      position relative
      left -2px
    .legend
      display flex
      // justify-content space-between
      .type
        height 18px
        line-height 18px
        font-size 12px
        color #FFFFFF
        padding 0 10px
        background #FA5A00
        margin-right 8px
        white-space: nowrap;
      .time
        height 12px
        font-size 12px
        color #999999
        line-height 18px
        margin-left auto
        white-space: nowrap;
      .list-title-large
        font-size 14px
        color #333333
        line-height 18px
        cursor pointer
        &:hover
          color #FA5A00
    .list-title
      font-size 14px
      color #333333
      line-height 18px
      margin-left 15px
      margin-top 15px
      margin-bottom 15px
    .list-tag
      margin-top 10px
      padding 0 15px
      display flex
      align-items center
      .name
        font-size 12px
        color #999999
      .tag
        display flex
        height 26px
        background #FFF4EA
        border-radius 13px
        align-items center
        margin-left 10px
        padding 0 10px
        font-size 12px
        color #FA5A00
        cursor pointer
        &:hover
          color #fff
          background #FA5A00
  .list-page
    display flex
    justify-content center
    // margin-top 10px
    span
      line-height 1
      cursor pointer
      color #FA5A00
      &.dis
        color #999
      &+span
        margin-left 10px
.sec-title, .sec-title-r
  line-height 1
  padding-bottom 16px
  font-size 16px
  display flex
  align-items center
  justify-content space-between
  span
    padding-right 20px
.sec-title-r
  .line
    flex 1
    border-top 1px solid #e9e9e9
  .lookmore
    color #FA5A00
    margin-left 20px
    font-size 14px
    cursor pointer
.sec-title
  &:after
    content ''
    flex 1
    border-top 1px solid #e9e9e9
  &-2
    &:after
      border-top 1px dashed #e9e9e9
</style>